var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSortIconActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.71601 7.97754C4.42319 8.27012 4.42271 8.74501 4.71503 9.03809L7.46406 11.792C7.60473 11.9328 7.79622 12.0117 7.99531 12.0117C8.19419 12.0116 8.38499 11.9327 8.52558 11.792L11.2746 9.03809C11.5672 8.74496 11.5667 8.27017 11.2736 7.97754C10.9805 7.6849 10.5057 7.68537 10.2131 7.97852L8.91579 9.27752C8.85281 9.34058 8.74503 9.29598 8.74503 9.20685L8.74503 4.77124C8.74501 4.35704 8.40923 4.02124 7.99503 4.02124C7.58083 4.02124 7.24505 4.35704 7.24503 4.77124L7.24503 9.20745C7.24503 9.29659 7.13721 9.34119 7.07424 9.27808L5.77753 7.97852C5.48489 7.68537 5.00916 7.6849 4.71601 7.97754Z",
    fill: "#0B5CFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortIconActive);
export default __webpack_public_path__ + "static/media/sort-icon-active.ab6ce81064ff1b4c1a68467e7c450656.svg";
export { ForwardRef as ReactComponent };